/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://muoemwj52rhyxgzzyd23v5p5bm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7tn725sxwzdorp22ndzaa2l42m",
    "aws_cognito_identity_pool_id": "us-east-1:811ab41f-69a6-486e-8c3d-7ff5c3c07b1f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_m5dVM00D3",
    "aws_user_pools_web_client_id": "1lh5iav2il0ekufnir4gcte9qq",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "photobucket1c6e4-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
